export const usStates = [
    { code: "al", name: "Alabama" },
    { code: "ak", name: "Alaska" },
    { code: "az", name: "Arizona" },
    { code: "ar", name: "Arkansas" },
    { code: "ca", name: "California" },
    { code: "co", name: "Colorado" },
    { code: "ct", name: "Connecticut" },
    { code: "de", name: "Delaware" },
    { code: "dc", name: "District of Columbia" },
    { code: "fl", name: "Florida" },
    { code: "ga", name: "Georgia" },
    { code: "hi", name: "Hawaii" },
    { code: "id", name: "Idaho" },
    { code: "il", name: "Illinois" },
    { code: "in", name: "Indiana" },
    { code: "ia", name: "Iowa" },
    { code: "ks", name: "Kansas" },
    { code: "ky", name: "Kentucky" },
    { code: "la", name: "Louisiana" },
    { code: "me", name: "Maine" },
    { code: "md", name: "Maryland" },
    { code: "ma", name: "Massachusetts" },
    { code: "mi", name: "Michigan" },
    { code: "mn", name: "Minnesota" },
    { code: "ms", name: "Mississippi" },
    { code: "mo", name: "Missouri" },
    { code: "mt", name: "Montana" },
    { code: "ne", name: "Nebraska" },
    { code: "nv", name: "Nevada" },
    { code: "nh", name: "New Hampshire" },
    { code: "nj", name: "New Jersey" },
    { code: "nm", name: "New Mexico" },
    { code: "ny", name: "New York" },
    { code: "nc", name: "North Carolina" },
    { code: "nd", name: "North Dakota" },
    { code: "oh", name: "Ohio" },
    { code: "ok", name: "Oklahoma" },
    { code: "or", name: "Oregon" },
    { code: "pa", name: "Pennsylvania" },
    { code: "ri", name: "Rhode Island" },
    { code: "sc", name: "South Carolina" },
    { code: "sd", name: "South Dakota" },
    { code: "tn", name: "Tennessee" },
    { code: "tx", name: "Texas" },
    { code: "ut", name: "Utah" },
    { code: "vt", name: "Vermont" },
    { code: "va", name: "Virginia" },
    { code: "wa", name: "Washington" },
    { code: "wv", name: "West Virginia" },
    { code: "wi", name: "Wisconsin" },
    { code: "wy", name: "Wyoming" },
];
export const usStateCodes = usStates.map(state => state.code);
//# sourceMappingURL=us-states.js.map